import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import _ from 'lodash';
import { css, cx } from 'emotion';
import ProcessField from 'components/core/fields/ProcessField';
import ProcessUtils from 'utils/ProcessUtils';
import ProcessService from 'services/ProcessService';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoMessages from 'components/core/help/InfoMessages';
import Constants from 'utils/Constants';


export default class ProcessRunLocationsField extends ProcessField {
    static propTypes = Object.assign({
        siteFacilities: PropTypes.array,
        labelWidth: PropTypes.string,
        runParameters: PropTypes.object,      // pass if running in runParameters mode
        runParameterErrors: PropTypes.object, // pass if running in runParameters mode
        isOwner: PropTypes.bool               // pass if running in runParameters mode
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    onRunLocationsUpdated = (fieldPath, fieldValue) => {
        let value = null;
        const valueConversionFunction = (location) => {
            const parts = location.value.split(' ');
            if (location !== null) {
                return {
                    site: parts[0],
                    fac: parts[1] ? parts[1] : null
                };
            }
            return null;
        };

        // If we are using run parameters, we are in single mode, and the select box passes us
        // a single object instead of an array
        if (this.props.runParameters) {
            const convertedValue = valueConversionFunction(fieldValue);
            if (convertedValue === null) {
                value = [];
            } else {
                value = [convertedValue];
            }
            
        } else {
            value = [...fieldValue].map(valueConversionFunction);
        }

        if (this.props.runParameters) {
            // First make sure that the selected value is set on the run parameters
            const parameters = _.cloneDeep(this.props.runParameters);
            parameters.run_locations = value;
            ProcessService.updateRunParameters(this.props.process.name, parameters);

            // Then make sure that if user is an owner and they have added a new run
            // location that wasn't saved to the process, that we udpate the field accordingly
            if (this.props.isOwner) {
                if (!ProcessUtils.hasRunLocation(this.props.process, value[0])) {
                    const runLocations = _.cloneDeep(this.props.process.run_locations);
                    runLocations.push(value[0]);
                    this.onFieldUpdated(fieldPath, runLocations);
                }

            }

        } else {
            this.onFieldUpdated(fieldPath, value);
        }
    };

    getRunLocations() {
        let runLocations = null;
        const conversionFunction = (location) => {
            let locationString = location.site;
            locationString += location.fac ? ` ${location.fac}` : '';
            return Constants.convertValueToSelectValue(locationString);
        };

        if (this.props.runParameters) {
            if (this.props.runParameters.run_locations.length > 0) {
                runLocations = conversionFunction(this.props.runParameters.run_locations[0]);
            }

        } else {
            runLocations = this.props.process.run_locations.map(conversionFunction);
        } 
        return runLocations;
    }

    getSiteFacilitiesOptions() {

        let siteFacilities = this.props.siteFacilities;
        if (this.props.runParameters && this.props.process.run_locations.length > 0) {
            // if we are in the run dialog, user can only choose from those defined for the process
            siteFacilities = ProcessUtils.getProcessRunLocations(this.props.process);
        }
        return ProcessUtils.getRunLocationOptions(siteFacilities);
    }

    render() {
        const runLocations = this.getRunLocations();
        const siteFacilitiesOptions = this.getSiteFacilitiesOptions();
        const label = this.props.runParameters ? 'Run Location' : 'Run Locations';
        const multi = this.props.runParameters ? false : true;
        const clearable = this.props.runParameters ? false : true;
        const errors = this.props.runParameters ? this.props.runParameterErrors : this.props.processErrors;
        const info = this.props.runParameters ? InfoMessages.runLocation : InfoMessages.runLocations;

        const style = css`
            align-self: flex-start !important;
        `;
        const labelWidth = this.props.labelWidth ? this.props.labelWidth : null;
       
        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={this.props.className}>
                <InfoBoxLabel
                    className={cx('nowrap', style)}
                    label={label}
                    message={info}
                    width={labelWidth}
                />
                <RIEComboBox
                    value={runLocations}
                    change={this.onRunLocationsUpdated}
                    fieldPath={['run_locations']}
                    isDisabled={!this.props.hasWritePermissions}
                    options={siteFacilitiesOptions}
                    multi={multi}
                    clearable={clearable}
                    processId={this.props.process.name}
                    processErrors={errors}
                    formDisplay={this.props.forceFormDisplay}
                />
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessRunLocationsField.js